import React, { useState } from "react";
import "./Checkbox.css";

const Checkbox = (props) => {
  const {
    label,
    isScrBound,
    setIsScrBound,
    isTitleSafe,
    setIsTitleSafe,
    isEmailSend,
    setIsEmailSend,
    isEmailSendtoAll,
    setIsEmailSendtoAll,
    isTermsandcon,
    setIsTermsandcon,
    isDisplayTitle,
    setIsDisplayTitle,
    setTerms,
    terms
  } = props;

  const handleCheck = () => {
    if (setIsTitleSafe) setIsTitleSafe(!isTitleSafe);
    if (setIsScrBound) setIsScrBound(!isScrBound);
    if (setIsEmailSend) setIsEmailSend(!isEmailSend);
    if (setIsEmailSendtoAll) setIsEmailSendtoAll(!isEmailSendtoAll);
    if (setIsTermsandcon) setIsTermsandcon(!isTermsandcon);
    if (setIsDisplayTitle) setIsDisplayTitle(!isDisplayTitle);
    if (setTerms) {
      setTerms(!terms);
    }
  };

  return (
    <div className="Check">
      <label className="labelBox">
        <input type="checkbox" checked={false} onChange={handleCheck} />
        <svg
          className={`checkbox ${
            isTitleSafe || isScrBound || isEmailSend || isEmailSendtoAll || isTermsandcon || isDisplayTitle || terms
              ? "checkbox--active"
              : ""
          }`}
          aria-hidden="true"
          viewBox="0 0 15 11"
          fill="none"
        >
          <path
            d="M1 4.5L5 9L14 1"
            strokeWidth="3"
            stroke={
              isTitleSafe  || isEmailSendtoAll || isDisplayTitle
                ? "#ffffff"
                : isScrBound || terms || isEmailSend
                ? "#ffffff"
                : "none"
            }
          />
        </svg>
        {label && <span className="chbx-Label">{label}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
